import React from 'react';
import style from './FoodItemCard.module.css';

/**
 * @param {{
 *   name: string, qty: string,
 *   sodium: number, protein: number
 * }} item
 * @param {() => void} onClickName  이름 클릭 → 상세/수정
 * @param {() => void} onRemove     X 버튼 → 삭제
 */
const FoodItemCard = ({ item, onClickName, onRemove }) => {

    return (
        <div className={style.card}>
            <div className={style.head}>
                <button type="button" className={style.nameBtn} onClick={onClickName}>
                    <span className={style.name}>{item.foodName}</span>
                </button>
                <button
                    type="button"
                    className={style.removeBtn}
                    onClick={onRemove}
                    aria-label={`${item.foodName} 삭제`}
                ></button>
            </div>
            <div className={style.body}>
                <span className={style.qty}>{`${item.eatAmount} ${item.counts}`}</span>
                <span className={style.nutri}>
                    <em className={style.nutriLabel}>나트륨</em>
                    {/* <em className={style.nutriValue}>{item.sodium}<i>mg</i></em> */}

                    {/* 정수 표기 (소수점 첫째 자리에서 반올림) */}
                    <em className={style.nutriValue}>{Math.round(Number(item.sodium ?? 0))}<i>mg</i></em>    
                </span>
                <span className={style.nutri}>
                    <em className={style.nutriLabel}>단백질</em>
                    {/* <em className={style.nutriValue}>{item.protein}<i>g</i></em> */}

                    {/* 소수점 첫째 자리까지 표기 (소수점 둘째 자리에서 반올림) */}
                    <em className={style.nutriValue}>{ Math.round(Number(item.protein ?? 0) * 10) / 10}<i>g</i></em>  
                </span>
            </div>
        </div>
    );
};

export default FoodItemCard;